import PropTypes from 'prop-types'
import React, {useState, useEffect} from 'react'
import i18n from 'i18next'
import actions from 'redux-auto'
import {connect} from 'react-redux'
import Loading from '#components/a/Loading'
import AusbildungsnachweiseKachel from '#components/o/Uebersicht/AusbildungsnachweiseKachel'
import Headline from '#components/a/Headline'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import Api from '#services/api'

function UebersichtAusbildungsnachweise({userInfo}) {
  const {firstname} = userInfo
  const [ausbildungsnachweiseModel, setAusbildungsnachweiseModel] = useState(undefined)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (ausbildungsnachweiseModel === undefined) {
      setAusbildungsnachweiseModel(null)
      setIsLoading(true)
      Api.getAusbildungsnachweiseAusbilderDashboard()
        .then(result => {
          setAusbildungsnachweiseModel(result)
          setIsLoading(false)
        })
        .catch(error => {
          actions.error.writeError({error})
          setIsLoading(false)
        })
    }
  }, [ausbildungsnachweiseModel])

  return (
    <div className="uebersicht">
      <div className="header-wrapper">
        <Headline importance={1} modifier="section" text={i18n.t('meineausbildung_page_title', [firstname])} />
      </div>
      <div className="uebersicht__page">
        {isLoading ? (
          <Loading />
        ) : (
          <AusbildungsnachweiseKachel ausbildungsnachweiseModel={ausbildungsnachweiseModel} showAllItems />
        )}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  userId: state.authentication.id,
})

UebersichtAusbildungsnachweise.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
  }).isRequired,
}

export default connect(mapStateToProps)(UserInfoHOC(UebersichtAusbildungsnachweise))
